import React, { useState, useRef } from "react";
import ColorThief from "colorthief";

const ColorExtractor = () => {
  const [imageSrc, setImageSrc] = useState(null);
  const [colors, setColors] = useState([]);
  const imageRef = useRef(null);
  console.log("colors", colors);
  // Utility function to convert RGB to HEX
  const rgbToHex = (r, g, b) =>
    "#" +
    [r, g, b]
      .map((x) => {
        const hex = x.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      })
      .join("");
  // Handle file upload and set the image source
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImageSrc(e.target.result);
        setColors([]); // Reset colors on new upload
      };
      reader.readAsDataURL(file);
    }
  };

  // Extract colors once the image is loaded
  const extractColors = () => {
    if (imageRef.current) {
      const colorThief = new ColorThief();

      try {
        const dominantColor = colorThief.getColor(imageRef.current); // Returns [R, G, B]
        const palette = colorThief.getPalette(imageRef.current, 4); // Returns [[R, G, B], ...]

        // Ensure colors are valid arrays
        const allColors = [dominantColor, ...palette].filter(
          (color) => Array.isArray(color) && color.length === 3
        );

        const normalizeColor = (value) => Math.round(value / 10) * 10;

        const uniqueColors = [];
        const hexSet = new Set();

        allColors.forEach((color) => {
          // Normalize RGB values
          const normalizedRGB = color.map(normalizeColor);
          const hex = rgbToHex(
            normalizedRGB[0],
            normalizedRGB[1],
            normalizedRGB[2]
          );

          if (!hexSet.has(hex)) {
            uniqueColors.push({
              rgb: `rgb(${color[0]}, ${color[1]}, ${color[2]})`,
              hex,
            });
            hexSet.add(hex);
          }
        });

        setColors(uniqueColors);
      } catch (error) {
        console.error("Error extracting colors:", error);
      }
    }
  };

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>Image Color Extractor</h1>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ marginBottom: "20px" }}
      />
      {imageSrc && (
        <div>
          <img
            ref={imageRef}
            src={imageSrc}
            alt="Uploaded"
            onLoad={extractColors}
            style={{
              maxWidth: "300px", // Limit the preview image width
              maxHeight: "200px", // Limit the preview image height
              objectFit: "contain", // Ensure the image fits within the given dimensions
              marginBottom: "20px",
              border: "1px solid #ddd",
              borderRadius: "8px", // Optional: Rounded corners
            }}
          />
        </div>
      )}
      {colors.length > 0 && (
        <div>
          <h3>Extracted Colors</h3>
          <div
            style={{ display: "flex", justifyContent: "center", gap: "10px" }}
          >
            {colors.map((color, index) => (
              <div key={index} style={{ textAlign: "center" }}>
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: color.rgb,
                    border: "1px solid #000",
                    marginBottom: "5px",
                  }}
                  title={`RGB: ${color.rgb}, HEX: ${color.hex}`}
                ></div>
                <div>
                  <p style={{ margin: 0, fontSize: "12px" }}>{color.rgb}</p>
                  <p
                    style={{ margin: 0, fontSize: "12px", fontWeight: "bold" }}
                  >
                    {color.hex}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorExtractor;
